/* src/app/requests/request-detail/request-log/highlight-entity/highlight-entity.component.scss */
/*# sourceMappingURL=highlight-entity.component.css.map */
